import { apiClient, type CreateTruckModelDto } from '@/libs/api'

/**
 * 車種の新規作成API
 */
export const createTruckModel = async (
  tenantKey: string,
  dto: CreateTruckModelDto
) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .truck_models.$post({ body: dto })
  return { data, errors }
}
